import {
  FETCH_FORM_DATA_END,
  FETCH_FORM_DATA_ERROR,
  FETCH_FORM_DATA_START,
  UPDATE_ACTIVE_FORM,
  UPDATE_ACTIVE_STEP,
} from '../actions/formWizard';

const initialState = {
  id: '',
  activeStep: '',
  isLoadingData: true,
  data: {},
};

export default (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case UPDATE_ACTIVE_FORM:
      return {
        ...state,
        id: action.payload.formId,
      };
    case UPDATE_ACTIVE_STEP:
      return {
        ...state,
        activeStep: action.payload.step,
      };
    case FETCH_FORM_DATA_START:
      return {
        ...state,
        isLoadingData: true,
      };
    case FETCH_FORM_DATA_END:
      return {
        ...state,
        data: action.payload,
        isLoadingData: false,
      };
    case FETCH_FORM_DATA_ERROR:
      return {
        ...state,
        data: null,
        isLoadingData: false,
      };
    /* istanbul ignore next -- @preserve */
    default:
      return state;
  }
};
